<app-selector label="Voice" [data]="voiceCoreService.voiceList$ | async" displayKey="name" [formControl]="ctrl"
    (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="voiceCoreService.loading" [hint]="hint">
</app-selector>
